import _, { startCase } from 'lodash'
import Vue from 'vue'

export default {
    initDefaultFields(state, key) {
        // console.log("vue state", state)
        Vue.set(state, key, {
            idenfoId: null,
            isIphone: null,
            dataSegmentId: null,
            parents:[],
            verificationStatus: {
                liveness: null,
                face: null,
            },
            companyHouseApiRiskoverrides:{
                hasInsolvencyHistory:null,
                undeliverableRegisteredOfficeAddress:null,
                confirmationStatementOverdue:null,
                accountsOverdue:null,
                registeredOfficeIsInDispute:null
  
            },
            customerVerificationStatus: {
                nadra: 'pending',
                criminalRecord: 'pending',
            },
            ipLocationDetails: state.ipLocationDetails,
            basicInfo: {
                token: '',
                firstName: null,
                middleName: '',
                lastName: '',
                fatherName: '',
                genderId: null,
                dateOfBirth: null,
                nationalityId: null,
                nationality: null,
                countryOfResidenceId: null,
                countryOfResidence: null,
                profileType: null,
                companyRelationship: null,
                gender: null,
                hasOtherNationalities: null,
                otherNationalities: null,
                companyStatus:null,
                companyType: null

            },
            identityInfo: {
                type: null,
                cardType: null,
                number: null,
                expiryDate: null,
                isLifetimeExpiry: null,
                passport : {
                    number: null,
                    expiryDate: null,
                    documentSummary:{},
                },
                documentSummary:{},
                documentSummaryBack:{},
            },
            occupationInfo: {
                workTypeId: null,
                industryId: null,
                taxId: null,
                tradeLicenseNumber: null,
                tradeLicenseExpiryDate: null,
                tradeLicenseIncorporationLocation: null,
                emiratesId:null,
                emiratesIdExpiryDate:null,
                companyName:null,
                industry: null,
                workType: null,
                relationshipStartDate:null,
                positionsInCompany : []
            },
            pepDeclaration: {
                anyPublicPos: null,
                posLastTwoMonths: null,
                everPublicPosition: null,
                diplomaticImmunity: null,
                relativeTwelveMonths: null,
                closeAssociateTwelveMonths: null,
                conviction: null,
                other: null,
            },
            sourceOfWealth: {
                evidenced: null,
                OtherEvidenced: null,
                evidenceDocument: {
                    fileName: null,
                    originalFileName: null,
                },
            },
            sourceOfFunds: {
                evidenced: null,
                OtherEvidenced: null,
                evidenceDocument: {
                    fileName: null,
                    originalFileName: null,
                },
            },

            contactInfo: {
                address: null,
                stateId: null,
                state: null,
                city: null,
                postalCode: null,
                isdCode: null,
                phoneNumber: null,
                email: null,
                confirmEmail: null,
                isdCountryCodeId: null,
            },
            accountInfo: {
                enhancedDueDiligence: {},
                // purposeOfActionId: null,
                products: [],
                // expectedCredit: null,
                // creditLimit: null,
                // grossIncome: null,
                // initialBalance: null,
                isf2f:null,
                isStr:null,
                strDate:null,
                strReason:null,
                enhancedDueDiligence:{
                    dateOfEdd:null,
                    isScrutinyPerformed:null,
                    scrutinyRemarks:null,
                    isCustBusInquired:null,
                    custBusInquiredRemarks:null,
                    isManagementApproval:null,
                    managementApprovalRemarks:null,
                    isFirstPayment:null,
                    firstPaymentRemarks:null
                }
            },
            documentInfo: {
                utility: {
                    fileName: null,
                    originalFileName: null,
                },
                identity: {
                    fileName: null,
                    originalFileName: null,
                },
                video: {
                    fileName: null,
                    originalFileName: null,
                },
                visaPage: {
                    fileName: null,
                    originalFileName: null,
                },
                fieldEmiratesID: {
                    fileName: null,
                    originalFileName: null,
                },
                fieldAddressProof: {
                    addressProofDocumentType:null,
                    fileName: null,
                    originalFileName: null,
                },
                fundsEvidenceDocument: {
                    fileName: null,
                    originalFileName: null,
                },
                wealthEvidenceDocument: {
                    fileName: null,
                    originalFileName: null,
                },
                fieldEmiratesIDBack: {
                    fileName: null,
                    originalFileName: null,
                },
                identityBack: {
                    fileName: null,
                    originalFileName: null,
                },
                licenseFront: {
                    fileName: null,
                    originalFileName: null,
                },
                licenseBack: {
                    fileName: null,
                    originalFileName: null,
                },
                additionalDocument: {
                    fileName: null,
                    originalFileName: null,
                },
                proofOfEmployment: {
                    fileName: null,
                    originalFileName: null,
                },
                EducationalDocument: {
                    fileName: null,
                    originalFileName: null,
                },
                consentForm: {
                    fileName: null,
                    originalFileName: null,
                },
                ocrPicture: {
                    fileName: null,
                    originalFileName: null,
                },
                scrutiny:{
                    fileName: null,
                    originalFileName: null,
                },
                custBusInquired:{
                    fileName: null,
                    originalFileName: null,
                },
                managementApproval:{
                    fileName: null,
                    originalFileName: null,
                },
                firstPayment:{
                    fileName: null,
                    originalFileName: null,
                },

            },
            customInfo: {},
            dynamicInputValues:{},
            type:'',
            signature:{},
            additionalInfo:{
                investment : null,
                gccNational:null
            },
            jointAccountInfo : {
                isJointAccount:null,
                name:null,
                relation:null,
                idNumber:null,
                email:null,
                address:null,
                phoneNumber:null,
                isdCode:null
            },
            minorAccountInfo: {
                isMinorAccount: null,
                name: null,
                relation: null,
                idNumber: null,
                email: null,
                address: null,
                phoneNumber: null,
                isdCode: null,
            },
            crsInfo: {
                countryTax1Id:null,
                countryTax1: null,
                tin1: null,
                reason1: null,
                otherReason1: null,
                countryTax2Id: null,
                countryTax2: null,
                tin2: null,
                reason2: null,
                otherReason2: null,
                countryTax3Id:null,
                countryTax3: null,
                tin3: null,
                reason3: null,
                otherReason3: null
            },
            fatcaInfo: {
                name: null,
                idNumber: null,
                placeOfBirthId: null,
                placeOfBirth: null,
                hasOtherResidency: null,
                otherResidency: null,
                isCountryTax: null,
                taxCountries: null,
                nationalities: null,
                isPowerAttorney: null,
                powerAttorneyName: null,
                powerAttorneyAddress: null,
            },
            uaePassDetails:{},
            reference:{}
        })
        state.isIndustrial = true
        state.isTaxIdRequired = false
    },
    initCustomField(state, { key, value }) {
        Vue.set(state.form.customInfo, key, value)
    },
    updateField(state, payload) {
        _.set(state.form, payload.key, payload.value)
    },
    setValue(state, { key, value }) {
        state[key] = value
    },
    deleteKey(state, { key }) {
        Vue.delete(state.form, key)
    },
    setDynamicInputValue(state, { parentKey,key, index,value }) {

        let currentObject = state.form.dynamicInputValues;
        if (!currentObject[parentKey]) {
            currentObject[parentKey] = index ? {} : [];
        }
        currentObject[parentKey][index] = value

    },
    updateDynamicInputValue(state, {parentKey, index, value}) {
        // Vue.set(state.form.dynamicInputValues[parentKey], index, value);
        for(let key in value) {
            Vue.set(state.form.dynamicInputValues[parentKey][index], key, value[key]);
        }
    },
    setIp(state, payload) {
        state.ip = payload
    },
    setIpLocationDetails(state, payload) {
        state.ipLocationDetails = payload
        let oldData = state.form ? state.form : {}
        Vue.set(state, 'form', {...oldData, ipLocationDetails: payload})
    },
    updateArray(state,{key,value,isPush,isFormArray}){
        if(!isFormArray){
            if(!isPush){
                state[key].pop()
            }else{
                state[key].push(value)
            }
        }else{
            if(!isPush){
                console.log("A1")
                state.form[key].pop()
            }else{
                state.form[key].push(value)
            }
            
        }    
    }
}
